import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDayNight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "currentColor",
	stroke: "currentColor",
	strokeWidth: "0.4px",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		d: "M4.29 27.71 27.7 4.3M24.32 30c-1.7 0-3.35-.6-4.66-1.66A7.6 7.6 0 0 1 17 20.93a7.5 7.5 0 0 1 5.3-5.79 8.4 8.4 0 0 0 .3 8.4 8.2 8.2 0 0 0 6.91 3.85l.49-.02A7.4 7.4 0 0 1 24.34 30zM9.43 15.43v2.28m0-16.57v2.29m-6 6H1.14m16.57 0h-2.28m-6 4.57a4.57 4.57 0 1 0 0-9.14 4.57 4.57 0 0 0 0 9.14ZM5.19 5.19 3.57 3.57m11.72 11.72-1.62-1.62m-8.48 0-1.62 1.62M15.29 3.57 13.67 5.2"
	})
});
export default SvgDayNight;
